import { useEffect } from 'react';
import { useStore } from "@tmsw/powerups.store";

// @see https://docs.pmnd.rs/zustand/recipes/recipes#memoizing-selectors
const setViewportSelector = ((state) => state.setViewport);
const viewportSelector = ((state) => state.viewport);

export function useViewport() {

  const viewport = useStore(viewportSelector);
  const setViewport = useStore(setViewportSelector);

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {

      const newViewport = {
        width: window.innerWidth,
        height: window.innerHeight
      };

      // Set window width/height to state
      setViewport(newViewport);
    };

    // Add event listener

    // add "orientationchange" handler because "resize" was called too earlier on certain mobile devices and does not return the accurate viewport height
    // add "resize" handler because "orientationchange" event is available on mobile devices and returns accurate viewport height but deprecated on modern non-mobile browsers
    window.addEventListener("orientationchange", handleResize);
    window.addEventListener("resize", handleResize);

    handleResize();
    // Remove event listener on cleanup
    return () => {
      window.removeEventListener("orientationchange", handleResize);
      window.removeEventListener("resize", handleResize);
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []); // Empty array ensures that effect is only run on mount

  return viewport;
}